import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { of } from 'rxjs';
import {
  LeaderboardParticipantPort,
  type ActivateLeaderboardParticipantParams,
} from '../../../domain/leaderboard/ports/leaderboard-participant.port';
import type { ActivateParticipantOutcome } from '../../../domain/leaderboard/models/activate-participant.model';

@Injectable({ providedIn: 'root' })
export class LeaderboardParticipantStubAdapter extends LeaderboardParticipantPort {
  activate(params: ActivateLeaderboardParticipantParams): Observable<ActivateParticipantOutcome> {
    const uid = params.uid?.trim();
    if (!uid || !Number.isFinite(params.commerceId) || params.commerceId <= 0) {
      return of({ status: 'skipped' });
    }
    return of({ status: 'activated' });
  }
}
